const ALLOWED_TYPES = [
  "image/png",
  "image/jpeg",
  "image/x-icon",
  "image/gif",
  "image/webp",
];
const MAX_SIZE = 5 * 1024 * 1024;

const validateIconFile = (file: File): Promise<string | null> => {
  if (!ALLOWED_TYPES.includes(file.type)) {
    return Promise.resolve("Dozwolone formaty: JPG, PNG, ICO, GIF, WEBP");
  }
  if (file.size > MAX_SIZE) {
    return Promise.resolve("Maksymalny rozmiar pliku to 5MB");
  }
  return Promise.resolve(null);
};

export default validateIconFile;
